<template>
  <div>
    <loading v-if="showLoading"></loading>
    <div class="vx-row mb-4">
      <div class="flex justify-between w-full px-4">
        <vs-button
          @click="addDiscount()"
          class="bg_l_green"
          v-has-permission="permission73"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("AddNewDiscount") }}
        </vs-button>
        <div class="flex gap-3">
          <div>
            <vs-button
              @click="uploadFile()"
              class="bg_m_green float-right"
              v-if="fileUploaded"
              :disabled="disabledBtn"
              v-has-permission="permission74"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("UploadFile") }}
            </vs-button>
            <label class="custom-file-upload mr-4">
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />

              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("ChooseFile") }}
              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
          </div>
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form v-if="showFilters">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <label class="vs-select--label">
            {{ $t("ProductName") }}
          </label>
          <treeselect
            v-model="gridSearchData.productId"
            name="productId"
            :multiple="false"
            :placeholder="$t('Search')"
            :async="true"
            :load-options="loadProducts"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label mb-1">{{ $t("FestivalName") }}</label>
          <v-select
            label="name"
            :options="allFestivals"
            v-model="gridSearchData.categoryId"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("FromDate")
          }}</label>

          <date-picker
            v-model="gridSearchData.startClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('FromDate')"
            :clearable="true"
          />
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("ToDate")
          }}</label>

          <date-picker
            v-model="gridSearchData.expireClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('ToDate')"
            :clearable="true"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitFilter()"
            >{{ $t("SubmitFilter") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("ResetFilter") }}</vs-button
          >
        </div>
      </div>
    </form>
    <div class="vx-row mt-6">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('DiscountType'), sort: 'DiscountType' },
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('ItemCode'), sort: 'ItemCode' },
            { title: $t('CalculationType'), sort: 'CalculationType' },
            { title: $t('DiscountAmount'), sort: 'DiscountAmount' },
            { title: $t('FromDate'), sort: 'FromDate' },
            { title: $t('ToDate'), sort: 'ToDate' },
            { title: $t('FestivalName'), sort: 'FestivalName' },
            { title: $t('Action'), sort: 'Action' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 12%">
              <span v-if="row.discountDiscriminator == 'Regular'">
                {{ $t("Basic") }}
              </span>
              <span v-if="row.discountDiscriminator == 'Festival'">
                {{ $t("Festival") }}
              </span>
              <span v-if="row.scheduleType == 0">
                {{ $t("Hourly") }}
              </span>
              <span v-if="row.scheduleType == 1">
                {{ $t("Daily") }}
              </span>
            </td>
            <td style="width: 18%">
              {{ row.product.persianName }}-{{ row.product.warrantyName }}-{{
                row.product.colorName
              }}
            </td>
            <td style="width: 7%">
              {{ row.product.itemCode }}
            </td>
            <td style="width: 8%">
              <span v-if="row.productDiscountType == '1'">
                {{ $t("Percent") }}
              </span>
              <span v-if="row.productDiscountType == '2'">
                {{ $t("quantitative") }}
              </span>
            </td>
            <td style="width: 10%">
              <span v-if="row.productDiscountType == '1'"
                >{{ row.discountAmount }}درصد</span
              >
              <span v-if="row.productDiscountType == '2'"
                >{{ Number(row.discountAmount).toLocaleString() }}ریال</span
              >
            </td>
            <td style="width: 12%">
              {{ row.startClock }}
            </td>
            <td style="width: 12%">
              {{ row.expireClock }}
            </td>
            <td style="width: 10%">
              <span v-if="row.festivalCategory != null">
                {{ row.festivalCategory.name }}
              </span>
              <span v-else>-</span>
            </td>
            <td style="width: 8%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-archive"
                @click.prevent="archiveDiscount(row)"
                class="d-inline"
                :title="$t('Archive')"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeModifyPopup"
    ></modify-popup>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

.vs-select--label {
  display: block;
}
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import ModifyPopup from "./ModifyPopup.vue";
import Loading from "@/components/loading/Loading.vue";

const dict = {
  custom: {
    festival: {
      required: "لطفا عنوان جشنواره را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_Discounts_ActiveDiscounts",
  data() {
    return {
      permission73: "CreateFestival",
      permission74: "ApplyDiscountsByExcelFile",
      gridDataSource: {
        type: "app",
        service: "Promotion/api/ProductDiscounts",
      },
      gridSearchData: {
        contractId: this.$route.params.id,
        isActive: true,
        productId: "",
        categoryId: "",
        startClock: "",
        expireClock: "",
        searchQueryNew: "",
        searchQueryOld: "",
      },
      ModifyPopup: false,
      modalModel: {},
      contractId: this.$route.params.id,
      showFilters: false,
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    Treeselect,
    DataGrid,
    ModifyPopup,
    Loading,
  },
  computed: {
    ...mapGetters({
      allFestivals: "festival/list",
    }),
  },
  methods: {
    ...mapActions({
      fetchFestivals: "festival/fetch",
      searchContractProducts: "sale/searchContractProducts",
      archiveFestival: "discount/archiveFestival",
      archiveRegular: "discount/archiveRegular",
      archiveSchedule: "discount/archiveSchedule",
      importPromotionExcel: "excel/importPromotionExcel",
    }),
    loadProducts({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchContractProducts({
              id: this.contractId,
              name: searchQuery,
            }).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.productId,
                  label: element.persianName,
                  name: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    archiveDiscount(row) {
      this.model = { id: row.id };
      if (row.festivalCategory) {
        this.$swal({
          title: "آیا از آرشیو این آیتم اطمینان دارید؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.archiveFestival(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "آیتم موردنظرآرشیو شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$refs.grid.renderGrid();
                }, 0);
              });
            });
          }
        });
      } else if (row.scheduleType == 0 || row.scheduleType == 1) {
        this.$swal({
          title: "آیا از آرشیو این آیتم اطمینان دارید؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.archiveSchedule(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "آیتم موردنظرآرشیو شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$refs.grid.renderGrid();
                }, 0);
              });
            });
          }
        });
      } else {
        this.$swal({
          title: "آیا از آرشیو این آیتم اطمینان دارید؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.archiveRegular(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "آیتم موردنظرآرشیو شد!",
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setTimeout(() => {
                  this.$refs.grid.renderGrid();
                }, 0);
              });
            });
          }
        });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFile() {
      this.showLoading = true;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importPromotionExcel(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
        this.showLoading = false;
      }, 1000);
    },
    submitFilter() {
      if (
        this.gridSearchData.startClock == this.gridSearchData.expireClock ||
        this.gridSearchData.startClock < this.gridSearchData.expireClock ||
        (this.gridSearchData.startClock != "" &&
          this.gridSearchData.expireClock == "")
      ) {
        this.gridSearchData = {
          ...this.gridSearchData,
          contractId: this.$route.params.id,
        };
        this.$refs.grid.renderGrid();
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
      }
    },
    resetForm() {
      this.gridSearchData = {};
      this.$refs.grid.renderGrid();
    },
    addDiscount() {
      this.modalModel = {};
      this.ModifyPopup = true;
      this.modalModel.scheduleType = null;
      this.modalModel.allFestivals = this.allFestivals;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
